export const getObjectFromKeys = (obj?: { key: string; value: unknown }[] | null) => {
  if (!obj) return {};
  return obj.reduce(
    (acc, item) => ({
      ...acc,
      [item.key]: item.value,
    }),
    {},
  );
};
